var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnFlashMessageWarning = function SvgIcnFlashMessageWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81652 4.01272C10.584 2.66763 12.5232 2.66763 13.2907 4.01272L21.8469 19.0079C22.6077 20.3412 21.6449 21.9991 20.1098 21.9991H2.99749C1.4624 21.9991 0.499602 20.3412 1.26038 19.0079L9.81652 4.01272ZM10.5536 10.9683C10.5536 10.416 11.0013 9.96832 11.5536 9.96832C12.1059 9.96832 12.5536 10.416 12.5536 10.9683V14.9683C12.5536 15.5206 12.1059 15.9683 11.5536 15.9683C11.0013 15.9683 10.5536 15.5206 10.5536 14.9683V10.9683ZM11.5536 18.9683C12.1059 18.9683 12.5536 18.5206 12.5536 17.9683C12.5536 17.416 12.1059 16.9683 11.5536 16.9683C11.0013 16.9683 10.5536 17.416 10.5536 17.9683C10.5536 18.5206 11.0013 18.9683 11.5536 18.9683Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnFlashMessageWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_flash_message_warning.21c42d34.svg";
export { ForwardRef as ReactComponent };